import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  margin-top: -15px;
  padding: 16px 32px;
  border-radius: 0px 0px 10px 10px;
`;
export const StatusTitle = styled.span<{ $type: string }>`
  color: ${({ $type, theme }) => ($type === 'success' ? theme.palette.white : theme.palette.error)};

  font-size: ${({ theme }) => theme.fs.sm};
  font-weight: bold;
`;
export const Statusdesc = styled.div`
  text-align: center;
  font-size: ${({ theme }) => theme.fs.xs};
  margin-top: ${({ theme }) => theme.spacing.x4};
`;
export const BtnStatus = styled.div`
  font-size: 16px;
  font-weight: bold;
  text-decoration: underline;
`;
export const Container = styled.div`
  background-color: #fab144;
  width: 100%;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
`;
